
import { KharonLogo } from '../components/Logo';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { 
    SparklesIcon, 
    HeartIcon, 
    ClockIcon, 
    DocumentTextIcon, 
    CheckIcon, 
    CalendarIcon, 
    BriefcaseIcon, 
    StarIcon, 
    UsersIcon, 
    ActivityIcon, 
    ArrowRightIcon, 
    MapPinIcon,
    XIcon,
    LockIcon
} from '../components/icons';


// --- Visualizers ---

const TimeEfficiencyVisualizer = () => {
    return (
        <div className="relative w-full h-auto min-h-[400px] bg-slate-900 rounded-[32px] overflow-hidden border border-slate-800 shadow-2xl p-8 flex flex-col justify-center gap-10 hover:shadow-[0_0_50px_rgba(197,164,126,0.1)] transition-shadow duration-500">
            <div className="absolute inset-0 opacity-10" style={{
                backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px)',
                backgroundSize: '40px 40px'
            }}></div>
            <div className="relative z-10">
                <div className="flex justify-between text-xs font-black uppercase text-slate-500 mb-2 tracking-widest">
                    <span>Proceso Tradicional</span>
                    <span>45 minutos</span>
                </div>
                <div className="h-12 w-full bg-slate-800 rounded-2xl relative overflow-hidden flex items-center">
                    {/* Simulated loading bar for traditional */}
                    <div className="h-full bg-slate-700/50 w-[30%] flex items-center justify-center border-r border-slate-800 animate-pulse">
                        <span className="text-[10px] text-slate-300 font-bold">Datos Manuales</span>
                    </div>
                    <div className="h-full bg-slate-700/50 w-[40%] flex items-center justify-center border-r border-slate-800 animate-pulse delay-75">
                        <span className="text-[10px] text-slate-300 font-bold">Redacción Contrato</span>
                    </div>
                    <div className="h-full bg-slate-700/50 w-[20%] flex items-center justify-center border-r border-slate-800 animate-pulse delay-150">
                        <span className="text-[10px] text-slate-300 font-bold">Firmas Papel</span>
                    </div>
                    <div className="h-full bg-slate-600/20 flex-grow flex items-center justify-center">
                        <span className="text-[10px] text-slate-500 font-bold">Atención</span>
                    </div>
                </div>
            </div>
            <div className="relative z-10">
                <div className="flex justify-between text-xs font-black uppercase text-white mb-2 tracking-widest">
                    <span className="text-primary-400">Con Kharon AI</span>
                    <span>Mismo Tiempo Total</span>
                </div>
                <div className="h-16 w-full bg-slate-800 rounded-2xl relative overflow-hidden flex items-center border border-primary-500/30 shadow-[0_0_30px_rgba(197,164,126,0.15)] group">
                    <div className="h-full bg-primary-500 w-[5%] flex items-center justify-center relative animate-slide-width" style={{ width: '5%' }}>
                        <span className="absolute -top-8 text-primary-500 font-black text-xs opacity-0 group-hover:opacity-100 transition-opacity animate-bounce-soft">2min</span>
                    </div>
                    <div className="h-full flex-grow bg-gradient-to-r from-primary-900/40 to-slate-800 flex items-center px-6 gap-4 animate-fade-in delay-300">
                        <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center animate-pulse-slow">
                            <HeartIcon className="w-4 h-4 text-white" />
                        </div>
                        <div>
                            <p className="text-sm font-bold text-white">Tiempo de Calidad para la Familia</p>
                            <p className="text-[10px] text-slate-400 font-medium">Escucha activa, empatía y acompañamiento.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="absolute left-[2.5%] top-[90px] bottom-[110px] w-0.5 bg-dashed border-l-2 border-dashed border-slate-700 z-0"></div>
        </div>
    );
};

const CalendarFeatureVisualizer = () => {
    return (
        <div className="relative w-full h-[400px] bg-slate-50 dark:bg-slate-900 rounded-[32px] overflow-hidden border border-slate-200 dark:border-slate-800 shadow-soft flex items-center justify-center p-8 group hover:shadow-luxury transition-all duration-500">
            {/* Timeline Background */}
            <div className="absolute top-0 bottom-0 left-12 w-0.5 bg-slate-200 dark:bg-slate-800"></div>
            
            <div className="w-full max-w-md space-y-4 relative z-10">
                {/* Event 1 */}
                <div className="flex gap-4 items-center opacity-50 animate-slide-in-right" style={{ animationDelay: '0.1s' }}>
                    <div className="w-8 text-right text-xs font-bold text-slate-400">09:00</div>
                    <div className="h-3 w-3 rounded-full bg-slate-300 dark:bg-slate-700 ring-4 ring-slate-50 dark:ring-slate-900"></div>
                    <div className="flex-grow p-3 rounded-xl bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                        <div className="h-2 w-24 bg-slate-200 dark:bg-slate-700 rounded mb-1"></div>
                        <div className="h-1.5 w-16 bg-slate-200 dark:bg-slate-700 rounded"></div>
                    </div>
                </div>

                {/* Event 2 (Active) */}
                <div className="flex gap-4 items-center animate-slide-in-right" style={{ animationDelay: '0.3s' }}>
                    <div className="w-8 text-right text-xs font-black text-slate-900 dark:text-white">11:30</div>
                    <div className="relative">
                        <div className="h-3 w-3 rounded-full bg-primary-500 ring-4 ring-slate-50 dark:ring-slate-900 shadow-lg shadow-primary-500/50 z-10 relative"></div>
                        <div className="absolute inset-0 bg-primary-500 rounded-full animate-ping opacity-75 h-3 w-3"></div>
                    </div>
                    <div className="flex-grow p-4 rounded-2xl bg-white dark:bg-slate-800 border border-primary-200 dark:border-primary-900 shadow-lg relative overflow-hidden transition-transform hover:scale-[1.02]">
                        <div className="absolute top-0 left-0 w-1 h-full bg-primary-500"></div>
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="font-bold text-sm text-slate-900 dark:text-white">Ceremonia Tanatorio Sur</p>
                                <p className="text-[10px] text-slate-500 mt-1">Sala 4 &bull; Inhumación</p>
                            </div>
                            <span className="px-2 py-0.5 bg-green-100 text-green-700 text-[9px] font-black rounded-full uppercase animate-pulse">Confirmado</span>
                        </div>
                    </div>
                </div>

                {/* Event 3 */}
                <div className="flex gap-4 items-center opacity-60 animate-slide-in-right" style={{ animationDelay: '0.5s' }}>
                    <div className="w-8 text-right text-xs font-bold text-slate-400">16:00</div>
                    <div className="h-3 w-3 rounded-full bg-slate-300 dark:bg-slate-700 ring-4 ring-slate-50 dark:ring-slate-900"></div>
                    <div className="flex-grow p-3 rounded-xl bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700">
                        <div className="h-2 w-32 bg-slate-200 dark:bg-slate-700 rounded mb-1"></div>
                        <div className="h-1.5 w-20 bg-slate-200 dark:bg-slate-700 rounded"></div>
                    </div>
                </div>
            </div>

            {/* Notification Pop */}
            <div className="absolute bottom-8 right-8 bg-slate-900 text-white px-4 py-3 rounded-2xl shadow-2xl flex items-center gap-3 animate-float" style={{ animationDelay: '1s' }}>
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <div>
                    <p className="text-[10px] font-black uppercase tracking-wider opacity-60">Agenda Actualizada</p>
                    <p className="text-xs font-bold">Sin conflictos de sala</p>
                </div>
            </div>
        </div>
    );
};

const ROICalculator = () => {
    const [servicesPerMonth, setServicesPerMonth] = useState(25);
    const timeSavedPerService = 43; // minutes (45 - 2)
    const totalMinutesSaved = servicesPerMonth * timeSavedPerService;
    const totalHoursSaved = (totalMinutesSaved / 60).toFixed(1);
    
    // Assume 40€/hour for a professional's time
    const moneySaved = (parseFloat(totalHoursSaved) * 40).toLocaleString('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

    return (
        <div className="bg-slate-900 rounded-[40px] p-8 md:p-12 shadow-luxury border border-white/10 relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 blur-[100px] rounded-full -mr-32 -mt-32"></div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10">
                <div className="space-y-8">
                    <h4 className="text-[10px] font-black uppercase tracking-[0.4em] text-primary-400">Calculadora de Impacto</h4>
                    <h5 className="text-4xl font-serif font-bold text-white">¿Cuánto tiempo recuperará su equipo?</h5>
                    <p className="text-slate-400 text-lg">Mueva el selector para estimar el ahorro operativo mensual basado en su volumen actual.</p>
                    
                    <div className="space-y-6 pt-4">
                        <div className="flex justify-between items-center mb-2">
                            <span className="text-sm font-bold text-white">Servicios al mes</span>
                            <span className="text-2xl font-black text-primary-500">{servicesPerMonth}</span>
                        </div>
                        <input 
                            type="range" 
                            min="5" 
                            max="100" 
                            step="5"
                            value={servicesPerMonth}
                            onChange={(e) => setServicesPerMonth(parseInt(e.target.value))}
                            className="w-full h-2 bg-slate-800 rounded-lg appearance-none cursor-pointer accent-primary-500"
                        />
                        <div className="flex justify-between text-[10px] font-black text-slate-500 uppercase tracking-widest">
                            <span>Bajo Volumen</span>
                            <span>Gran Grupo</span>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div className="p-8 bg-white/5 rounded-3xl border border-white/10 flex flex-col items-center text-center space-y-4 hover:bg-white/10 transition-all">
                        <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center text-primary-400">
                            <ClockIcon className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-3xl font-black text-white">{totalHoursSaved}h</p>
                            <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mt-1">Horas Libres / Mes</p>
                        </div>
                    </div>
                    <div className="p-8 bg-white/5 rounded-3xl border border-white/10 flex flex-col items-center text-center space-y-4 hover:bg-white/10 transition-all">
                        <div className="w-12 h-12 rounded-full bg-indigo-500/20 flex items-center justify-center text-indigo-400">
                            <StarIcon className="w-6 h-6" />
                        </div>
                        <div>
                            <p className="text-3xl font-black text-white">{moneySaved}</p>
                            <p className="text-[10px] font-black text-slate-500 uppercase tracking-[0.2em] mt-1">Ahorro Estimado</p>
                        </div>
                    </div>
                    <div className="sm:col-span-2 p-6 bg-primary-500 rounded-2xl flex items-center justify-center gap-4 group-hover:scale-[1.02] transition-transform cursor-pointer">
                        <span className="text-slate-900 font-black text-xs uppercase tracking-widest">Optimizar mi funeraria ahora</span>
                        <ArrowRightIcon className="w-4 h-4 text-slate-900" />
                    </div>
                </div>
            </div>
        </div>
    );
};

const PricingCard: React.FC<{
    title: string;
    price: string;
    description: string;
    features: string[];
    recommended?: boolean;
    onAction: () => void;
}> = ({ title, price, description, features, recommended, onAction }) => (
    <div className={`relative p-8 rounded-[32px] border-2 flex flex-col h-full transition-all duration-300 ${recommended ? 'bg-slate-900 text-white border-slate-900 shadow-2xl scale-105 z-10' : 'bg-white dark:bg-slate-900 text-slate-900 dark:text-white border-slate-100 dark:border-slate-800 shadow-xl'}`}>
        {recommended && (
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-primary-500 to-primary-600 text-white px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg">
                Recomendado
            </div>
        )}
        <div className="mb-8">
            <h3 className="text-xl font-bold mb-2">{title}</h3>
            <p className={`text-sm ${recommended ? 'text-slate-400' : 'text-slate-500 dark:text-slate-400'}`}>{description}</p>
        </div>
        <div className="mb-8 flex items-baseline gap-1">
            <span className="text-4xl font-serif font-bold">{price}€</span>
            <span className={`text-sm font-bold ${recommended ? 'text-slate-500' : 'text-slate-400'}`}>/mes</span>
        </div>
        <ul className="space-y-4 mb-8 flex-grow">
            {features.map((feature, i) => (
                <li key={i} className="flex items-center gap-3 text-sm font-medium">
                    <CheckIcon className={`w-5 h-5 ${recommended ? 'text-primary-400' : 'text-primary-500'}`} />
                    <span>{feature}</span>
                </li>
            ))}
        </ul>
        <button 
            onClick={onAction}
            className={`w-full py-4 rounded-xl font-bold text-sm transition-all ${recommended ? 'bg-white text-slate-900 hover:bg-slate-100' : 'bg-slate-900 dark:bg-white text-white dark:text-slate-900 hover:opacity-90'}`}
        >
            Comenzar Ahora
        </button>
    </div>
);

const PAGE_CONTENT: Record<string, { title: string; subtitle: string; body: React.ReactNode }> = {
    'aviso-legal': {
        title: 'Aviso Legal',
        subtitle: 'Información general sobre el titular del sitio web.',
        body: (
            <>
                <p>En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico.</p>
                <h3>1. Datos Identificativos</h3>
                <p>El titular del presente sitio web es KHARON SYSTEMS S.L., con domicilio social en Paseo de la Castellana 200, Madrid, y C.I.F. número B-12345678.</p>
                <h3>2. Propiedad Intelectual</h3>
                <p>El código fuente, los diseños gráficos, las imágenes, las fotografías, los sonidos, las animaciones, el software, los textos, así como la información y los contenidos que se recogen en el presente sitio web están protegidos por la legislación española sobre los derechos de propiedad intelectual e industrial a favor de KHARON SYSTEMS S.L.</p>
            </>
        )
    },
    'privacidad': {
        title: 'Política de Privacidad',
        subtitle: 'Cómo tratamos sus datos personales.',
        body: (
            <>
                <p>KHARON se compromete a proteger y respetar su privacidad. Esta política establece las bases sobre las que trataremos cualquier dato personal que recabemos de usted.</p>
                <h3>1. Información que recopilamos</h3>
                <p>Podemos recopilar y tratar los siguientes datos sobre usted: Información que nos proporciona al rellenar formularios en nuestro sitio web, suscribirse a nuestro servicio, o solicitar otros servicios.</p>
                <h3>2. Uso de la información</h3>
                <p>Utilizamos la información que tenemos sobre usted para: Asegurarnos de que el contenido de nuestro sitio web se presenta de la manera más efectiva para usted y para su ordenador.</p>
            </>
        )
    },
    'condiciones': {
        title: 'Términos de Uso',
        subtitle: 'Condiciones de acceso y utilización del servicio.',
        body: (
            <>
                <p>Al acceder y utilizar este servicio, usted acepta cumplir con los siguientes términos y condiciones.</p>
                <h3>1. Uso del Servicio</h3>
                <p>Usted se compromete a utilizar el servicio únicamente para fines legales y de acuerdo con estos términos. No debe utilizar el servicio de ninguna manera que pueda dañar, deshabilitar, sobrecargar o deteriorar nuestros servidores o redes.</p>
                <h3>2. Cuentas de Usuario</h3>
                <p>Para acceder a ciertas funciones del servicio, es posible que deba crear una cuenta. Usted es responsable de mantener la confidencialidad de su cuenta y contraseña.</p>
            </>
        )
    }
};

const ContentPageLayout = ({ slug, onBack }: { slug: string; onBack: () => void }) => {
    const content = PAGE_CONTENT[slug];
    if (!content) return null;
    return (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 animate-fade-in z-[100] relative">
            <div className="max-w-4xl mx-auto px-8 py-24">
                <button onClick={onBack} className="mb-12 flex items-center gap-2 text-xs font-black uppercase tracking-[0.2em] text-primary-600 hover:text-primary-700 transition-all">
                    <ArrowRightIcon className="w-4 h-4 rotate-180" />
                    Volver
                </button>
                <header className="mb-16 border-b border-slate-200 dark:border-slate-800 pb-8">
                    <h1 className="text-4xl md:text-6xl font-serif font-bold text-slate-900 dark:text-white mb-4">{content.title}</h1>
                    <p className="text-xl text-slate-500 font-medium">{content.subtitle}</p>
                </header>
                <div className="prose prose-slate dark:prose-invert max-w-none prose-headings:font-serif">
                    {content.body}
                </div>
                <div className="mt-20 pt-10 border-t border-slate-200 dark:border-slate-800 text-center">
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em]">Documento Legal Oficial &middot; KHARON 2026</p>
                </div>
            </div>
        </div>
    );
};

export const LandingPage: React.FC<{ onTryNow?: () => void }> = ({ onTryNow }) => {
    const navigate = useNavigate();
    const [isAnnual, setIsAnnual] = useState(true);
    const [activeSlug, setActiveSlug] = useState<string | null>(null);

    const handleAccess = () => {
        if (onTryNow) onTryNow();
        else navigate('/login');
    };

    useEffect(() => { 
        if (activeSlug) window.scrollTo(0, 0); 
    }, [activeSlug]);

    if (activeSlug) {
        return <ContentPageLayout slug={activeSlug} onBack={() => setActiveSlug(null)} />;
    }

    return (
        <div className="bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 min-h-screen font-sans selection:bg-primary-500 selection:text-white overflow-x-hidden scroll-smooth">
            
            {/* Global Gradient Overlays */}
            <div className="fixed inset-0 pointer-events-none z-0">
                <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary-500/5 blur-[120px] rounded-full animate-pulse-slow"></div>
                <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-indigo-500/5 blur-[150px] rounded-full animate-pulse-slow" style={{ animationDelay: '3s' }}></div>
            </div>

            {/* Navigation */}
            <nav className="fixed w-full z-[100] top-0 transition-all duration-500 bg-white/70 dark:bg-slate-950/70 backdrop-blur-xl border-b border-slate-200/50 dark:border-slate-800/50">
                <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
                    <div className="flex items-center gap-12">
                        <div className="cursor-pointer hover:opacity-80 transition-opacity" onClick={() => navigate('/dashboard')}>
                            <KharonLogo className="h-7 text-slate-900 dark:text-white" />
                        </div>
                        <div className="hidden lg:flex items-center gap-8">
                            <a href="#solucion" className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors">La Solución</a>
                            <a href="#modulos" className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors">Módulos</a>
                            <a href="#seguridad" className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors">Seguridad</a>
                            <a href="#precios" className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors">Planes</a>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={handleAccess}
                            className="px-6 py-2.5 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-full text-[10px] font-black uppercase tracking-widest hover:scale-105 active:scale-95 transition-all shadow-xl"
                        >
                            Acceso
                        </button>
                    </div>
                </div>
            </nav>

            {/* Cinematic Hero Section */}
            <header className="relative pt-40 pb-24 lg:pt-56 lg:pb-40 px-6 z-10">
                <div className="max-w-7xl mx-auto text-center space-y-10">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary-500/20 bg-primary-500/5 backdrop-blur-md animate-fade-in">
                        <SparklesIcon className="w-4 h-4 text-primary-500 animate-pulse" />
                        <span className="text-[10px] font-black uppercase tracking-[0.2em] text-primary-600 dark:text-primary-400">Revolución Funeraria 5.0</span>
                    </div>

                    <h1 className="text-6xl lg:text-9xl font-serif font-bold leading-[0.95] text-slate-900 dark:text-white tracking-tighter animate-fade-in-up">
                        Excelencia funeraria<br/>
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 via-primary-400 to-indigo-400">sin fricción.</span>
                    </h1>

                    <p className="text-xl md:text-2xl text-slate-500 dark:text-slate-400 leading-relaxed max-w-3xl mx-auto animate-fade-in-up font-medium" style={{ animationDelay: '0.2s' }}>
                        La primera plataforma inteligente que se adapta automáticamente a la <strong>normativa de su región</strong>. Reduzca el tiempo de gestión de 45 a 2 minutos hoy mismo.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-6 justify-center pt-8 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                        <button onClick={handleAccess} className="px-10 py-5 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-2xl font-black text-xs uppercase tracking-widest shadow-[0_20px_50px_rgba(0,0,0,0.2)] hover:shadow-primary-500/20 hover:-translate-y-1 transition-all">
                            Comenzar Trial de 7 días
                        </button>
                        <button className="px-10 py-5 bg-white dark:bg-slate-900 text-slate-900 dark:text-white border border-slate-200 dark:border-slate-800 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-slate-50 transition-all">
                            Ver Demo en Vivo
                        </button>
                    </div>

                    {/* Trust Indicators */}
                    <div className="pt-24 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.4em] mb-10">Líderes en Innovación Funeraria</p>
                        <div className="flex flex-wrap justify-center gap-12 opacity-40 grayscale hover:grayscale-0 transition-all duration-700">
                             <div className="flex items-center gap-2 font-serif text-xl font-bold">STYGIA <span className="text-xs font-sans text-slate-400">GROUP</span></div>
                             <div className="flex items-center gap-2 font-serif text-xl font-bold">ELISIUM <span className="text-xs font-sans text-slate-400">MEMORIAL</span></div>
                             <div className="flex items-center gap-2 font-serif text-xl font-bold">ANUBIS <span className="text-xs font-sans text-slate-400">PARTNERS</span></div>
                             <div className="flex items-center gap-2 font-serif text-xl font-bold">PHOENIX <span className="text-xs font-sans text-slate-400">SERVICES</span></div>
                        </div>
                    </div>
                </div>
            </header>


            {/* Solution Section: Comparison */}
            <section id="solucion" className="py-32 bg-white dark:bg-slate-900 border-y border-slate-100 dark:border-slate-800 relative z-10">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-center">
                        <div className="space-y-8">
                            <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-primary-500">Inteligencia Normativa</h2>
                            <h3 className="text-5xl lg:text-6xl font-serif font-bold text-slate-900 dark:text-white leading-[1.1]">
                                Cero errores legales,<br/>máximo cumplimiento.
                            </h3>
                            <p className="text-lg text-slate-500 dark:text-slate-400">
                                KHARON es el único sistema que conoce los decretos locales. Detecta el origen y destino del traslado y carga automáticamente la documentación exigida por Salud Pública en cada región.
                            </p>
                            
                            <div className="space-y-4">
                                {[
                                    { label: 'Proceso Tradicional', value: '45 min', color: 'bg-slate-200' },
                                    { label: 'Con Kharon AI', value: '2 min', color: 'bg-primary-500', premium: true }
                                ].map((item, i) => (
                                    <div key={i} className={`p-6 rounded-2xl border ${item.premium ? 'bg-slate-900 border-slate-800 text-white shadow-2xl scale-[1.02]' : 'bg-slate-50 border-slate-100 text-slate-900'}`}>
                                        <div className="flex justify-between items-center mb-2">
                                            <span className="text-[10px] font-black uppercase tracking-widest opacity-60">{item.label}</span>
                                            <span className="text-xl font-bold">{item.value}</span>
                                        </div>
                                        <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden">
                                            <div className={`h-full ${item.color} transition-all duration-1000`} style={{ width: item.premium ? '5%' : '95%' }}></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="relative">
                            <div className="absolute inset-0 bg-primary-500/10 blur-[100px] rounded-full"></div>
                            <TimeEfficiencyVisualizer />
                        </div>
                    </div>
                </div>
            </section>

            {/* ROI Calculator Section */}
            <section className="py-24 bg-slate-50 dark:bg-slate-950 relative z-10 overflow-hidden">
                <div className="max-w-7xl mx-auto px-6">
                    <ROICalculator />
                </div>
            </section>

            {/* Modules Section: Ecosystem */}
            <section id="modulos" className="py-32 bg-white dark:bg-slate-900 relative z-10">
                <div className="max-w-7xl mx-auto px-6 text-center mb-20">
                    <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-primary-500 mb-6">Ingeniería Propietaria</h2>
                    <h3 className="text-5xl font-serif font-bold text-slate-900 dark:text-white">Un ecosistema diseñado<br/>para la excelencia.</h3>
                </div>

                <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[
                        {icon: <SparklesIcon />, title: 'Vision Engine OCR', desc: 'Convierta un DNI en un expediente completo en 2 segundos. Precisión total sin tecleo manual.' },
                        { icon: <DocumentTextIcon />, title: 'Smart Templates', desc: 'Biblioteca inteligente adaptada por defecto a los requisitos legales de su zona de operación.' },
                        { icon: <CalendarIcon />, title: 'Logística de Traslados', desc: 'Gestión automatizada según los requisitos específicos de la región de origen y destino.' },
                        { icon: <UsersIcon />, title: 'Prestigio de Marca', desc: 'Digitalice la firma y entrega de documentos en iPad para una imagen moderna y profesional.' },
                        { icon: <ActivityIcon />, title: 'Rentabilidad Real', desc: 'Analice márgenes por servicio y optimice sus costes operativos con datos en tiempo real.' },
                        { icon: <LockIcon />, title: 'Cumplimiento Blindado', desc: 'Seguridad de grado militar y cumplimiento estricto del RGPD para la tranquilidad de las familias.' }
                    ].map((module, i) => (
                        <div key={i} className="group p-8 bg-white dark:bg-slate-900 rounded-[32px] border border-slate-100 dark:border-slate-800 shadow-soft hover:shadow-luxury transition-all duration-500 hover:-translate-y-2">
                            <div className="w-12 h-12 bg-slate-50 dark:bg-slate-800 rounded-2xl flex items-center justify-center text-primary-500 mb-6 group-hover:scale-110 group-hover:bg-primary-500 group-hover:text-white transition-all">
                                {React.cloneElement(module.icon as React.ReactElement<any>, { className: "w-6 h-6" })}
                            </div>
                            <h4 className="text-xl font-bold text-slate-900 dark:text-white mb-4">{module.title}</h4>
                            <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed font-medium">
                                {module.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </section>


            {/* Security Section: Confidence */}
            <section id="seguridad" className="py-32 bg-slate-900 text-white relative overflow-hidden z-10">
                <div className="absolute top-0 left-0 w-full h-full opacity-10" style={{
                    backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)',
                    backgroundSize: '32px 32px'
                }}></div>
                <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10">
                    <div className="space-y-8 animate-fade-in-up">
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-md">
                            <LockIcon className="w-4 h-4 text-primary-400" />
                            <span className="text-[10px] font-black uppercase tracking-[0.2em] text-white">Seguridad de Grado Bancario</span>
                        </div>
                        <h3 className="text-5xl font-serif font-bold leading-tight">Tu legado digital,<br/>protegido hoy y siempre.</h3>
                        <p className="text-xl text-slate-400 font-medium">
                            Sabemos que gestionas información extremadamente sensible. Por eso, Kharon utiliza los más altos estándares de cifrado y cumplimiento legal.
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
                            {[
                                { title: 'Cifrado AES-256', desc: 'Datos en reposo y en tránsito protegidos por cifrado militar.' },
                                { title: 'RGPD Compliant', desc: 'Cumplimiento estricto de la normativa europea de protección de datos.' },
                                { title: 'Backups Diarios', desc: 'Copias de seguridad automáticas en centros de datos europeos.' },
                                { title: 'Audit Logs', desc: 'Registro detallado de cada acción realizada en la plataforma.' }
                            ].map((item, i) => (
                                <div key={i} className="flex gap-4 p-4 bg-white/5 rounded-2xl border border-white/10 hover:bg-white/10 transition-colors">
                                    <div className="mt-1"><CheckIcon className="w-4 h-4 text-primary-400" /></div>
                                    <div className="space-y-1">
                                        <p className="font-bold text-sm">{item.title}</p>
                                        <p className="text-xs text-slate-500">{item.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="relative">
                        <div className="aspect-square bg-gradient-to-br from-primary-500/20 to-indigo-500/20 rounded-full blur-[100px] absolute inset-0"></div>
                        <div className="relative p-12 bg-white/5 rounded-[48px] border border-white/10 backdrop-blur-sm">
                            <div className="text-center space-y-8">
                                <div className="inline-block p-8 bg-white/10 rounded-full border border-white/10 animate-pulse-slow">
                                    <LockIcon className="w-20 h-20 text-primary-400" />
                                </div>
                                <div>
                                    <p className="text-5xl font-black mb-2">100%</p>
                                    <p className="text-[10px] font-black uppercase tracking-[0.4em] text-slate-500">Uptime Garantizado</p>
                                </div>
                                <div className="flex justify-center gap-4">
                                    <div className="h-2 w-2 bg-green-500 rounded-full animate-pulse"></div>
                                    <span className="text-xs font-bold text-green-500 uppercase tracking-widest">Sistemas Operativos</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Pricing Section: Optimized */}
            <section id="precios" className="py-32 bg-white dark:bg-slate-900 relative z-10 transition-colors duration-1000">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-24 max-w-2xl mx-auto space-y-6">
                        <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-primary-500">Inversión en Futuro</h2>
                        <h3 className="text-5xl md:text-6xl font-serif font-bold">Planes diseñados para<br/>crecer contigo.</h3>
                        <div className="pt-8">
                            <div className="inline-flex p-1.5 bg-slate-100 dark:bg-slate-800 rounded-2xl">
                                <button onClick={() => setIsAnnual(false)} className={`px-10 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${!isAnnual ? 'bg-white dark:bg-slate-700 shadow-xl text-slate-900 dark:text-white' : 'text-slate-500'}`}>Mensual</button>
                                <button onClick={() => setIsAnnual(true)} className={`px-10 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${isAnnual ? 'bg-white dark:bg-slate-700 shadow-xl text-slate-900 dark:text-white' : 'text-slate-500'}`}>Anual (-20%)</button>
                            </div>
                        </div>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
                        <PricingCard 
                            title="Independent" 
                            price={isAnnual ? "149" : "189"} 
                            description="Ideal para funerarias familiares que buscan modernizar su atención." 
                            features={[
                                "OCR de identidad ilimitado", 
                                "Motor de plantillas básico", 
                                "Calendario inteligente", 
                                "Soporte email prioritario",
                                "1 Sede única"
                            ]} 
                            onAction={handleAccess} 
                        />
                        <PricingCard 
                            title="Enterprise" 
                            recommended 
                            price={isAnnual ? "249" : "319"} 
                            description="La solución definitiva para grupos funerarios con alto volumen." 
                            features={[
                                "Todo lo de Independent",
                                "Multi-Sede avanzada", 
                                "Gestión de flota y personal", 
                                "Integración API personalizada",
                                "Soporte 24/7 dedicado"
                            ]} 
                            onAction={handleAccess} 
                        />
                    </div>
                    
                    <div className="mt-20 text-center animate-fade-in-up">
                        <p className="text-slate-500 dark:text-slate-400 font-medium mb-6">¿Necesitas algo a medida para un gran grupo?</p>
                        <a href="mailto:oamengual@gmail.com" className="text-sm font-black uppercase tracking-widest text-primary-600 hover:text-primary-500 flex items-center justify-center gap-2 mx-auto transition-all group">
                            Contactar con Ventas <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-2 transition-transform" />
                        </a>
                    </div>
                </div>
            </section>

            {/* Testimonials Section: Social Proof */}
            <section id="testimonios" className="py-32 bg-slate-50 dark:bg-slate-950 relative z-10">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="text-center mb-20">
                        <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-primary-500 mb-6">Voces del Sector</h2>
                        <h3 className="text-5xl font-serif font-bold text-slate-900 dark:text-white">Confianza que trasciende.</h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            { quote: "Kharon nos ha devuelto el propósito. Ya no pasamos el 70% del tiempo tecleando datos, sino escuchando a las familias.", author: "Elena Martínez", role: "Directora de Funeraria San José" },
                            { quote: "La precisión del OCR y la firma biométrica han eliminado el error humano en nuestros contratos legales.", author: "Ricardo Visedo", role: "Gerente de Grupo Elisium" },
                            { quote: "Es el primer software que realmente entiende que en este sector, la tecnología debe ser invisible y respetuosa.", author: "Carlos Soria", role: "Director de Operaciones Memoria Viva" }
                        ].map((testimony, i) => (
                            <div key={i} className="p-10 bg-white dark:bg-slate-900 rounded-[40px] border border-slate-100 dark:border-slate-800 shadow-soft relative">
                                <StarIcon className="w-8 h-8 text-primary-500/20 absolute top-8 right-8" />
                                <p className="text-lg font-serif italic text-slate-700 dark:text-slate-300 leading-relaxed mb-8">
                                    "{testimony.quote}"
                                </p>
                                <div>
                                    <p className="font-black text-slate-900 dark:text-white text-sm uppercase tracking-widest">{testimony.author}</p>
                                    <p className="text-xs text-slate-500 font-medium mt-1">{testimony.role}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Footer: Refined */}
            <footer className="bg-white dark:bg-slate-900 pt-32 pb-12 px-6 border-t border-slate-100 dark:border-slate-800 relative z-10">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-24">
                        <div className="col-span-1 md:col-span-2 space-y-8">
                            <KharonLogo className="h-8 text-slate-900 dark:text-white" />
                            <p className="text-slate-500 dark:text-slate-400 max-w-sm text-lg leading-relaxed font-medium">
                                Redefiniendo la administración funeraria mediante tecnología ética, invisible y de alta precisión.
                            </p>
                        </div>
                        <div>
                            <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-400 mb-8">Legal</h4>
                            <ul className="space-y-4 text-sm font-bold text-slate-600 dark:text-slate-400">
                                <li><button onClick={() => setActiveSlug('aviso-legal')} className="hover:text-primary-500 transition-colors">Aviso Legal</button></li>
                                <li><button onClick={() => setActiveSlug('privacidad')} className="hover:text-primary-500 transition-colors">Política de Privacidad</button></li>
                                <li><button onClick={() => setActiveSlug('condiciones')} className="hover:text-primary-500 transition-colors">Términos de Uso</button></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-[10px] font-black uppercase tracking-[0.3em] text-slate-400 mb-8">Contacto</h4>
                            <ul className="space-y-4 text-sm font-bold text-slate-600 dark:text-slate-400">
                                <li>soporte@kharon.io</li>
                                <li>+34 910 000 000</li>
                                <li className="font-medium text-slate-500 leading-relaxed">Paseo de la Castellana 200,<br/>Madrid, España</li>
                            </ul>
                        </div>
                    </div>
                    <div className="pt-12 border-t border-slate-100 dark:border-slate-800 flex flex-col md:flex-row justify-between items-center gap-8">
                        <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.4em]">© 2026 Kharon Cloud Systems . All Rights Reserved.</p>
                        <div className="flex items-center gap-4 px-4 py-2 bg-slate-50 dark:bg-slate-800 rounded-full border border-slate-100 dark:border-slate-700">
                            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                            <span className="text-[10px] font-black text-slate-600 dark:text-slate-400 uppercase tracking-widest">Sistemas Operativos</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};
